import React from "react";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
} from "@mui/material";
import {
    compareMonthKeys,
    getLastCompletedMonthKey,
    isSelectableMonthKey,
} from "../../utils/dateUtils";

export default function MonthRangeSelector({
    monthOptions,
    startMonth,
    endMonth,
    onChangeStart,
    onChangeEnd,
    startLabel = "From Month",
    endLabel = "To Month",
    sx,
    anchorDate = new Date(),
    allowCurrentMonth = false,
}) {
    const maxMonthKey = allowCurrentMonth
        ? `${anchorDate.getFullYear()}-${String(anchorDate.getMonth() + 1).padStart(2, "0")}`
        : getLastCompletedMonthKey(anchorDate);
    const isOptionDisabled = (monthKey) =>
        !isSelectableMonthKey(monthKey, { anchorDate, maxMonthKey });

    return (
        <Box mt={2} sx={sx}>
            <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                alignItems="stretch"
            >
                <FormControl size="small" sx={{ minWidth: 220 }}>
                    <InputLabel id="pearli-start-month-label">{startLabel}</InputLabel>
                    <Select
                        labelId="pearli-start-month-label"
                        label={startLabel}
                        value={startMonth || ""}
                        onChange={(e) => {
                            const nextStartMonth = e.target.value;
                            if (isOptionDisabled(nextStartMonth)) return;
                            onChangeStart(nextStartMonth);
                        }}
                    >
                        {monthOptions.map((m) => (
                            <MenuItem
                                key={m.key}
                                value={m.key}
                                disabled={
                                    isOptionDisabled(m.key) ||
                                    (Boolean(endMonth) &&
                                        compareMonthKeys(m.key, endMonth) > 0)
                                }
                            >
                                {m.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl size="small" sx={{ minWidth: 220 }}>
                    <InputLabel id="pearli-end-month-label">{endLabel}</InputLabel>
                    <Select
                        labelId="pearli-end-month-label"
                        label={endLabel}
                        value={endMonth || ""}
                        onChange={(e) => {
                            const nextEndMonth = e.target.value;
                            if (isOptionDisabled(nextEndMonth)) return;
                            onChangeEnd(nextEndMonth);
                        }}
                    >
                        {monthOptions.map((m) => (
                            <MenuItem
                                key={m.key}
                                value={m.key}
                                disabled={
                                    isOptionDisabled(m.key) ||
                                    (Boolean(startMonth) &&
                                        compareMonthKeys(m.key, startMonth) < 0)
                                }
                            >
                                {m.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Stack>
        </Box>
    );
}
